(function() {
  'use strict';
  angular.module('general')
  .factory('watchForVersionChange',['$http', '$timeout', '$window', '$q', function($http, $timeout, $window, $q) {
    let deferred;
    function poll(resolve) {
      $timeout(() => {
        $http.get('version').then((response) => {
          if (appVersion && appVersion != '?version=' + response.data.version) {
            resolve(response.data.version, appVersion);
          } else {
            poll(resolve);
          }
        }, () => {
          poll(resolve);
        });
      }, 60 * 1000); //1 minute
    }
    
    return function watchForVersionChange() {
      if (!deferred) {
        deferred = $q.defer();
        poll(deferred.resolve);
      }
      return deferred.promise;
    };
  }]);
})();
